<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('groupDetail.description') }}
        @if (!is2025) {
          <span>{{ t('groupDetail.classSelectionNote') }}</span>
        }
      </p>
    </div>
  </div>
  <drdp-report-search [multiSelectClassrooms]="true" [multiSelectSites]="true" [hasSubfilters]="true"
    (showReportClicked)="showReport($event)" (downloadReportClicked)="downloadReport($event)" [is2025]="is2025"
  (clearClicked)="handleClear()" [requiredFields]="requiredFields"></drdp-report-search>
  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }
</div>
</ng-container>
